import _regeneratorRuntime from '@babel/runtime/helpers/esm/regeneratorRuntime';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';

function interstitial(aemAxiosIntance) {
  function getInterstitial() {
    return _getInterstitial.apply(this, arguments);
  }
  function _getInterstitial() {
    _getInterstitial = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return aemAxiosIntance.get('/interstitial');
          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _getInterstitial.apply(this, arguments);
  }
  return {
    getInterstitial: getInterstitial
  };
}

export { interstitial as default };
//# sourceMappingURL=interstitial.js.map
